module.exports = __webpack_public_path__ + "static/media/YF57_2.44e09e7a.jpg";